<template>
	<div v-if="isSubmitResponse" class="emailSubmitResponseModal">
		<div class="modalBackdrop" @click="closeSubmitResponseModal"></div>
		<div class="modalWrapper">
			<section
				:class="responseErrorMessage ? 'modalHeader error' : 'modalHeader'"
			>
				<span v-if="!responseErrorMessage">Submitted Successfully</span>
				<span v-else>Failed</span>
			</section>
			<section class="modalBody">
				<p v-if="!responseErrorMessage">
					You will receive an email with CSV file <br />
					attached in few minutes
				</p>
				<p v-else>{{ responseErrorMessage }}</p>
			</section>
			<section class="modalFooter">
				<button
					name="closeSubmitResponseModal-btn"
					type="button"
					:class="responseErrorMessage ? 'closeButton error' : 'closeButton'"
					@click="closeSubmitResponseModal"
				>
					{{ responseErrorMessage ? "Okay" : "Done" }}
				</button>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		"isSubmitResponse",
		"closeSubmitResponseModal",
		"responseErrorMessage"
	]
};
</script>
